.badge {
  background-color: rgba(var(--color-state--error-rgb), 0.6);
}

.icon {
  width: 2.4rem;
  height: 2.4rem;
}
